module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av607-f0cbe2a232dfa5869a2dec57ce88ec53.jpg";